import { createListenerMiddleware, isAnyOf, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import { DataStatus } from '@repo/ui/utils'

import type { RootState } from '@/store'

import { storeActions, ThunkExtra } from '../actions'
import { setSortOption } from '../beneficiary-list-filters/slice'
import { getCurrentOrganization } from '../helpers'
import { setBeneficiaryListColumnVisibility, setCaseWorkerPreferences } from './slice'

const buildCaseWorkerPreferencesListener = (extra: ThunkExtra) => {
  const listener = createListenerMiddleware<
    RootState,
    ThunkDispatch<RootState, ThunkExtra, UnknownAction>,
    ThunkExtra
  >({ extra })

  listener.startListening({
    matcher: isAnyOf(setSortOption, setBeneficiaryListColumnVisibility),
    effect: async (_action, listenerApi) => {
      const organization = getCurrentOrganization(listenerApi.getState())
      if (!DataStatus.isFulfilled(organization)) return
      const caseWorkerPreferences = listenerApi.getState().caseWorkerPreferences
      await listenerApi.extra.altApi.caseWorkerPreferences.updateOne(
        organization.id,
        caseWorkerPreferences,
      )
    },
  })

  listener.startListening({
    actionCreator: storeActions.initOrganization.fulfilled,
    effect: async (_action, listenerApi) => {
      const organization = getCurrentOrganization(listenerApi.getState())
      if (!DataStatus.isFulfilled(organization)) return
      const caseWorkerPreferences = await listenerApi.extra.altApi.caseWorkerPreferences.findOne(
        organization.id,
      )
      if (!caseWorkerPreferences) return
      listenerApi.dispatch(setCaseWorkerPreferences(caseWorkerPreferences))
      listenerApi.dispatch(setSortOption(caseWorkerPreferences.beneficiaryListSortOption))
    },
  })

  return listener
}

export const caseWorkerPreferencesMiddleware = function (extra: ThunkExtra) {
  return buildCaseWorkerPreferencesListener(extra).middleware
}
